import { Injectable } from "@angular/core";
import {
	ActivatedRouteSnapshot,
	CanActivate,
	RouterStateSnapshot,
	UrlTree
} from "@angular/router";
import { Observable } from "rxjs";
import { AccessMatrixService } from "@ds-common-services/utility-services/access-matrix.service";

@Injectable({
	providedIn: "root"
})
export class LoggedInGuard implements CanActivate {
	constructor(private accessMatrixService: AccessMatrixService) {}
	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	):
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree>
		| boolean
		| UrlTree {
		if (state.url === "/" && this.accessMatrixService.isAuthenticated()) {
			this.accessMatrixService.navigateAfterLogin();
			return false;
		}
		return true;
	}
}
